import { AuthService } from 'src/app/core/services/auth/auth.service';
import { Component, Output, EventEmitter, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { CreateGyanService } from 'src/app/core/services/create-gyan/create-gyan.service';
import { HttpErrorResponse } from '@angular/common/http';
import { LocalStorageService } from './../../core/services/local-storage/local-storage.service';
import { CommonServiceService } from './../../core/services/common-service/common-service.service';
import { Subscription } from 'rxjs';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { ToastrService } from 'ngx-toastr';
import { SanitizeService } from 'src/app/shared/services/sanitize.service';
import { SubmitgyanService } from 'src/app/core/services/submit-gyan/submitgyan.service';
@Component({
    selector: 'app-search-section',
    templateUrl: './search-section.component.html',
    styleUrls: ['./search-section.component.scss'],
})
export class SearchSectionComponent {
    @Output() gyanTitle = new EventEmitter<string>();
    @Output() gyanTitleResponseGet = new EventEmitter<any>();
    @ViewChild('gyanTitleText') gyanTitleText!: ElementRef;

    private loadingAfterSocket: Subscription;
    private gotoDashboard: Subscription;
    isLoading: boolean = true;
    RapidQueryListPermission: boolean = false;
    preSearches: any;
    searchText: string = '';
    showDropdown: boolean = false;
    highlighted: string = '';
    faAngleDown = faAngleDown;
    signInUser: boolean = false;
    inputValue: string = '';
    getUserDetails: any;

    constructor(
        private createGyanService: CreateGyanService,
        private localStorageService: LocalStorageService,
        private commonServiceService: CommonServiceService,
        private authService: AuthService,
        private elementRef: ElementRef,
        private cd: ChangeDetectorRef,
        private toastrService: ToastrService,
        private sanitizeService: SanitizeService,
        private submitgyanservice: SubmitgyanService,
    ) {
        // calling subject to show and hide dahsboard screen
        this.loadingAfterSocket = this.commonServiceService.loadingAfterSocket$.subscribe((value) => {
            if (value && this.authService.isSignInUser()) {
                this.waitForUserDetails().then((userDetails) => {
                    if (userDetails) {
                        this.RapidQueryListPermission = this.authService.getAccessList('RapidQueryList');
                        if (this.RapidQueryListPermission && this.isSignInUser()) {
                            console.log('logged in and has permission');
                            this.getSearchList();
                        } else {
                            this.isLoading = false;
                        }
                    }
                });
                //  console.log('calling subject to show and hide dahsboard screen');
            }
        });

        this.gotoDashboard = this.commonServiceService.gotoDashboard$.subscribe((data: any) => {
            if (data) {
                setTimeout(() => {
                    this.autoFocusTextbox();
                }, 100);
            }
        });
    }

    waitForUserDetails(): Promise<any> {
        return new Promise((resolve) => {
            const checkLocalStorage = () => {
                const userDetails = localStorage.getItem('userDetails');
                if (userDetails) {
                    resolve(JSON.parse(userDetails));
                } else {
                    setTimeout(checkLocalStorage, 100); // Poll every 500ms
                }
            };

            checkLocalStorage();
        });
    }

    ngOnInit() {
        if (!this.authService.isSignInUser()) {
            console.log('not logged in and calling');
            this.getSearchList();
        }
    }

    getSearchList() {
        this.submitgyanservice.getSearchDropDownData().subscribe((resp: any) => {
            console.log('the response for search list is', JSON.stringify(resp));
            this.preSearches = resp.queryList.sort((a: { index: number }, b: { index: number }) => a.index - b.index);
            this.isLoading = false;
            // this.preSearches = resp.queryList;
        });
    }

    get filteredSearches() {
        return this.preSearches.filter((search: { query: string }) => search.query.toLowerCase().includes(this.searchText.toLowerCase()));
    }

    onFocus() {
        this.showDropdown = true;
    }

    onBlur() {
        setTimeout(() => {
            this.showDropdown = false;
        }, 200);
    }

    onSelect(searchStr: string) {
        const signUpData = this.authService.getGuestSignUpJson();
        console.log('the selected string is', searchStr);
        this.searchText = searchStr;
        this.showDropdown = false;
        const searchGyanreq = {
            searchString: searchStr,
            offset: 0,
            guestSignUp: signUpData,
            personId: this.authService.getPersonId(),
        };
        this.initiateSearchAPIcallCorporate(searchGyanreq);
        this.showDropdown = false;
    }

    onPaste(event: ClipboardEvent): void {
        event.preventDefault();

        if (event.clipboardData) {
            const pastedData = event.clipboardData.getData('text');
            const sanitizedData = this.sanitizeService.sanitizeInput(pastedData);
            if (pastedData !== sanitizedData) {
                this.toastrService.warning('Invalid characters are not allowed');
            }
            this.gyanTitleText.nativeElement.value = sanitizedData;
        }
    }

    sanitizeInput(event: any, gyanTitleText: HTMLInputElement) {
        const gyanTitle = gyanTitleText.value;
        console.log('the string is', gyanTitle);

        const sanitizedData = this.sanitizeService.sanitizeInput(gyanTitle);
        if (gyanTitle !== sanitizedData) {
            this.toastrService.warning('Invalid characters are not allowed');
        }
        this.gyanTitleText.nativeElement.value = sanitizedData;
    }

    initiateSearch(event: any, gyanTitleText: HTMLInputElement) {
        const signUpData = this.authService.getGuestSignUpJson();

        //to trim the unwanted spaces
        let gyanTitle = gyanTitleText.value.trim();
        console.log('the string is', gyanTitle);

        const sanitizedValue = this.sanitizeService.sanitizeInput(gyanTitle);

        // Only update and emit if the sanitized value differs
        if (gyanTitle !== sanitizedValue) {
            gyanTitle = sanitizedValue;
        }

        console.log('NewGyanTitle', gyanTitle);
        //call the API only if the string is not empty
        if (gyanTitle) {
            const searchTerm = gyanTitle;
            //empty the string immediately after the search
            this.gyanTitleText.nativeElement.value = '';
            event.preventDefault();
            this.localStorageService.removeItem('gyanData');
            // this.createGyanService.callWebsocket.next(true);
            const searchGyanreq = {
                searchString: searchTerm,
                offset: 0,
                guestSignUp: signUpData,
                personId: this.authService.getPersonId(),
            };
            this.gyanTitleText.nativeElement.blur();
            this.initiateSearchAPIcall(searchGyanreq, gyanTitleText);
        } else {
            console.log('empty gyan search string');
        }
    }

    initiateSearchAPIcall(searchGyanreq: any, gyanTitleText: HTMLInputElement) {
        const signUpData = this.authService.getGuestSignUpJson();
        this.createGyanService.submitGyan(searchGyanreq).subscribe({
            next: (response: any) => {
                if (response.statusCode === 200) {
                    //    console.log(response);
                    const gyanData = { gyanName: response.data.topicName, gyanId: response.data.topicId, gyanType: 'rapid', gyanCreatedNow: 'yes' };
                    this.localStorageService.setItem('gyanData', gyanData);
                    //to open pages for newly created gyan
                    this.commonServiceService.setCreateGyanInitiated(true);
                    //setting up data in cookies after new account created
                    if (response.data.user) this.authService.setGuestSignUpResponse(response.data.user, signUpData.uuid);
                    //to get newly created gyan to left panel
                    this.commonServiceService.setCallPreviousSearchGyan(true);
                    gyanTitleText.value = '';
                    this.searchText = '';

                    //making the below subject false because it is calling in clickback
                    setTimeout(() => {
                        this.commonServiceService.setCreateGyanInitiated(false);
                    }, 10);
                } else {
                    this.gyanTitleText.nativeElement.value = '';
                    this.searchText = '';
                    console.log('Unexpected status code: ', response.statusCode);
                }
            },
            error: (error: HttpErrorResponse) => {
                console.log('Error: ', error.message);
                this.gyanTitleText.nativeElement.value = '';
                this.searchText = '';
            },
            complete: () => {
                this.gyanTitleText.nativeElement.value = '';
                this.searchText = '';
                //    console.log('Submit Gyan Called successfully');
            },
        });
    }

    initiateSearchAPIcallCorporate(searchGyanreq: any) {
        const signUpData = this.authService.getGuestSignUpJson();
        this.createGyanService.submitGyan(searchGyanreq).subscribe({
            next: (response: any) => {
                if (response.statusCode === 200) {
                    //    console.log(response);
                    const gyanData = { gyanName: response.data.topicName, gyanId: response.data.topicId, gyanType: 'rapid', gyanCreatedNow: 'yes' };
                    this.localStorageService.setItem('gyanData', gyanData);
                    //to open pages for newly created gyan
                    this.commonServiceService.setCreateGyanInitiated(true);
                    //setting up data in cookies after new account created
                    if (response.data.user) this.authService.setGuestSignUpResponse(response.data.user, signUpData.uuid);
                    //to get newly created gyan to left panel
                    this.commonServiceService.setCallPreviousSearchGyan(true);
                    this.searchText = '';

                    //making the below subject false because it is calling in clickback
                    setTimeout(() => {
                        this.commonServiceService.setCreateGyanInitiated(false);
                    }, 10);
                } else {
                    this.searchText = '';
                    console.log('Unexpected status code: ', response.statusCode);
                }
            },
            error: (error: HttpErrorResponse) => {
                console.log('Error: ', error.message);
                this.searchText = '';
            },
            complete: () => {
                this.searchText = '';
                //    console.log('Submit Gyan Called successfully');
            },
        });
    }
    // InitiateCorporateSearch(searchStr: string) {
    //     const isValidSearch = this.preSearches.some((search: { searchStr: string; }) =>
    //       search.searchStr.toLowerCase() === searchStr.toLowerCase()
    //     );

    //     if (isValidSearch) {
    //       const signUpData = this.authService.getGuestSignUpJson();
    //       const searchGyanreq = {
    //         searchString: searchStr,
    //         offset: 0,
    //         guestSignUp: signUpData,
    //         personId: this.authService.getPersonId(),
    //       };
    //       this.initiateSearchAPIcall(searchGyanreq);
    //       this.showDropdown = false;
    //     } else {
    //       console.log('No valid match found. Search not initiated.');
    //       this.toastrService.warning('Select one of the search term from the search list')
    //     }
    // }

    isMobile: boolean = false;
    checkWidth() {
        const width = window.innerWidth;
        console.log(width);
        if (width < 768) this.isMobile = true;
        else this.isMobile = false;
    }

    autoFocusTextbox() {
        this.checkWidth();
        if (!this.isMobile) {
            this.gyanTitleText.nativeElement.focus();
        }
    }

    isSignInUser() {
        //add a local variable and set it to - advanced
        if (this.authService.isSignInUser()) this.signInUser = true;
        else this.signInUser = false;
        return this.authService.isSignInUser();
    }

    ngOnDestroy() {
        this.loadingAfterSocket.unsubscribe();
        this.gotoDashboard.unsubscribe();
    }
}
